// extracted by mini-css-extract-plugin
module.exports = {"typeahead":"styles__typeahead--2S7zh","container":"styles__container--3hLUe"};